<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => sameFuc(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class matchSizeMenus extends Vue {
        get menuList() {
            return {
                list: [
                    { key: "sameWidth", label: this.$t("width") },
                    { key: "sameHeight", label: this.$t("height") },
                    { key: "sameAngle", label: this.$t("angle") },
                    { key: "sameSize", label: this.$t("width&height") },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        sameFuc(type) {
            this.$track("menu", "layout", type);
            switch (type) {
                case "sameWidth":
                    window["_view"].sameSize(0);
                    break;
                case "sameHeight":
                    window["_view"].sameSize(1);
                    break;
                case "sameAngle":
                    window["_view"].sameSize(2);
                    break;
                case "sameSize":
                    window["_view"].sameSize(3);
                    break;
            }
            this.closeDrop();
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "width&height": "等大小",
    "angle": "等角度",
    "width": "等宽",
    "height": "等高"
  },
  "en": {
    "width&height": "Equal Size",
    "angle": "Equal Angle",
    "width": "Equal Width",
    "height": "Equal Height"
  },
  "fr": {
    "width&height": "Taille Égale",
    "angle": "Angle Égale",
    "width": "Largeur Égale",
    "height": "Hauteur Égale"
  },
  "de": {
    "width&height": "Breite & Höhe",
    "width": "Breite ",
    "height": "Höhe",
    "angle": "Winkel"
  },
  "jp": {
    "width&height": "縦横比をロック",
    "width": "幅",
    "height": "高さ",
    "angle": "角度"
  },
  "es": {
    "width&height": "Igual tamaño",
    "angle": "Ángulo igual",
    "width": "Ancho igual",
    "height": "Igualdad de altura"
  },
  "pt": {
    "width&height": "Tamanho Igual",
    "angle": "Ângulo Igual",
    "width": "Largura Igual",
    "height": "Altura Igual"
  },
  "it": {
    "width&height": "Stessa Dimensione",
    "angle": "Stesso Angolo",
    "width": "Stessa Larghezza",
    "height": "Stessa Altezza"
  },
  "tw": {
    "width&height": "等大小",
    "angle": "等角度",
    "width": "等寬",
    "height": "等高"
  }
}
</i18n>
